import * as React from 'react';
import Panel from './Panel';
import axios from 'axios';
// @ts-ignore
import * as Cookies from 'js-cookie';

export interface PanelCollectionProps {
    uri: string;
}

export default class PanelCollection extends React.Component<PanelCollectionProps, {}> {
    state = {
        isFetching: false,
        messages: [] as any[]
    };

    constructor(props:PanelCollectionProps) {
        super(props);
        this.addClosedPanel = this.addClosedPanel.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    getClosedPanels() {
        let closedPanelsString = Cookies.get('closed-message-panels');
        if (closedPanelsString === undefined || closedPanelsString === '') {
            return [];
        }
        return closedPanelsString.split(',');
    }

    addClosedPanel(id:string) {
        let closedPanels = this.getClosedPanels();
        closedPanels.push(id);
        Cookies.set('closed-message-panels', closedPanels.join(','), {secure: true});
    }

    async fetchData() {
        this.setState({ ...this.state, isFetching: true });
        const response = await axios.get(this.props.uri);
        let data = response.data as any[];
        let closedPanels = this.getClosedPanels();
        this.setState({
            ...this.state,
            isFetching: false,
            messages: data.filter(message => {
                return closedPanels.indexOf(message.uniqueIdentifier) === -1;
            })
        });
    }

    render() {
        return (
            <div className="cc-panel-collection">
                {this.state.messages.map(message => (
                    <Panel onClose={this.addClosedPanel} key={message.uniqueIdentifier} id={message.uniqueIdentifier} severity={parseInt(message.severity)} title={message.title ?? null} content={message.messageHtml ?? null} />
                ))}
            </div>
        )
    }
}
